import styled from 'styled-components';

export default styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${props => props.disabled ? 'rgba(145, 150, 178, 1)' : 'inherit'};
  
  font-family: ${props => props.titleAsFont ? props.titleAsFont : 'inherit'};
`;
